import { render } from "./VaPageNotFoundCustom.vue?vue&type=template&id=23bc3efc"
import script from "./VaPageNotFoundCustom.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundCustom.vue?vue&type=script&lang=js"

import "./VaPageNotFoundCustom.vue?vue&type=style&index=0&id=23bc3efc&lang=scss"
script.render = render

export default script